import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { cyclePath } from '../health-cycle/useStartHealthCycle'
import { formatDate } from '../health-cycle/cycleStatus'

// VH-247 stage 2: "what changed since the last blood test", from the agreed cycle's follow-up.
// Counts only — the follow-up's own paragraph is English and lives on the cycle page.
export function WhatChangedCard({ agreed }) {
  const { t, i18n } = useTranslation()
  const changed = agreed.what_changed
  const date = (d) => formatDate(`${d}T12:00:00`, i18n.language)

  return (
    <section className="card" data-testid="what-changed">
      <div className="card-body space-y-2 text-sm">
        <h2 className="text-lg font-semibold text-gray-900">{t('home.whatChanged.title')}</h2>
        {agreed.follows && changed ? (
          <>
            <p className="text-gray-700">
              {t('home.whatChanged.since', { date: date(agreed.follows.blood_test_date) })}
            </p>
            <ul className="flex flex-wrap gap-2">
              <li className="px-2 py-0.5 rounded bg-green-100 text-green-800">
                {t('home.whatChanged.better', { count: changed.improved ?? 0 })}
              </li>
              <li className="px-2 py-0.5 rounded bg-red-100 text-red-800">
                {t('home.whatChanged.worse', { count: changed.worsened ?? 0 })}
              </li>
              <li className="px-2 py-0.5 rounded bg-gray-100 text-gray-700">
                {t('home.whatChanged.unchanged', { count: changed.unchanged ?? 0 })}
              </li>
            </ul>
            {changed.coverage_pct != null && (
              <p className={changed.coverage_sufficient ? 'text-gray-500' : 'text-yellow-800'}>
                {t(changed.coverage_sufficient ? 'home.whatChanged.coverage' : 'home.whatChanged.coverageLow',
                  { percent: Math.round(changed.coverage_pct) })}
              </p>
            )}
            <Link to={cyclePath(agreed.id)} className="inline-block font-medium text-primary-600 hover:text-primary-700">
              {t('home.whatChanged.open')}
            </Link>
          </>
        ) : (
          <p className="text-gray-600">{t('home.whatChanged.first')}</p>
        )}
      </div>
    </section>
  )
}

export default WhatChangedCard
